import { INDUSTRIES, INDUSTRIES_BY_KEY } from "../data/industries";
import type { Industry, IndustryKey } from "../types";

export function getIndustry(key: IndustryKey): Industry {
  return INDUSTRIES_BY_KEY[key];
}

type GetIndustriesOptions = {
  limit?: number;
};

export function getIndustries(
  keys?: IndustryKey | IndustryKey[],
  options?: GetIndustriesOptions,
): Industry[] {
  if (!keys) {
    return INDUSTRIES.slice(0, options?.limit);
  }

  const list = Array.isArray(keys) ? keys : [keys];

  return list
    .map(key => INDUSTRIES_BY_KEY[key])
    .filter(Boolean)
    .slice(0, options?.limit);
}
